import { useAvisoStatusCondicoes } from "./use-aviso-status-condicoes";
import { AvisoStatusCondicoesView } from "./view-aviso-status-condicoes";

export function AvisoStatusCondicoes() {
  const vm = useAvisoStatusCondicoes();

  return <AvisoStatusCondicoesView {...vm} />;
}

export type * from "./types-aviso-status-condicoes";
